<template>
<router-view />
</template>

<script>
export default {
  name: 'OperationsRecord',
  routeInfo: {
    label: '运维记录',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/08Operations/02Log/index.vue